export const SPECIAL_PROJECT_CAROUSEL_OPTIONS = {
  spaceBetween: 16,
  slidesPerView: 4,
} as const;
